import React, { useEffect, useState } from "react";
import Logo from "./Logo";

/**
 * Recreates the original 2025-05-31 xaelserpent.com splash sequence:
 *  1. Full-screen black "blink" overlay
 *  2. Centered yellow logo fades in
 *  3. After 1.5s: blink + logo fade out, header logo fades in
 *  4. Links staggered-reveal and footer fade-in are triggered via the
 *     returned `ready` flag (consumer decides what to animate).
 *
 * Runs once per browser tab on mount. `onReady` fires when animation done.
 */
export default function Splash({ onReady }) {
  const [step, setStep] = useState(0); // 0=blink+logo visible, 1=fading, 2=hidden

  useEffect(() => {
    // Skip splash if navigated within session (to keep it snappy on internal nav)
    if (sessionStorage.getItem("xs_splashed")) {
      setStep(2);
      onReady?.();
      return;
    }
    const t1 = setTimeout(() => setStep(1), 1500);
    const t2 = setTimeout(() => {
      setStep(2);
      sessionStorage.setItem("xs_splashed", "1");
      onReady?.();
    }, 2600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onReady]);

  if (step === 2) return null;

  return (
    <>
      <div
        data-testid="splash-blink"
        className={`xs-blink ${step === 1 ? "fade" : ""}`}
      />
      <Logo
        className={`xs-logo-splash ${step === 0 ? "show" : ""}`}
        alt="xaelserpent logo splash"
        data-testid="splash-logo"
      />
    </>
  );
}
